export const TEST_ID = 'updateBatteryForm';
